import React, { ReactNode, useEffect } from "react";
import styles from "./BaseListView.module.css";
import Layout from "../layout/Layout";
import closeButton from '../../assets/icons/close.svg';
import { BackgroundColorType } from "./types";

export type BaseListViewProps = {
    onClose: () => void;
    headerContent?: ReactNode;
    children?: ReactNode;
    animate?: boolean;
    baseZIndex?: number;
    footerContent?: ReactNode;
    backgroundColor?: BackgroundColorType;
    sheetClassName?: string;
};

const BaseListView: React.FC<BaseListViewProps> = ({
    onClose,
    headerContent,
    children,
    animate = true,
    baseZIndex = 0,
    footerContent,
    backgroundColor,
    sheetClassName,
}) => {
    // use the parent's layout view
    const footerButton = (
        <div className={styles.footerContainer}>
            <button className={styles.closeButton} onClick={onClose}>
                <img src={closeButton} />
            </button>
        </div>);

    const finalZIndex = baseZIndex + 1;

    let backgroundColorStyle = '';
    switch (backgroundColor) {
        case BackgroundColorType.PURPLE:
            backgroundColorStyle = styles.purple;
            break;
        case BackgroundColorType.ORANGE:
        default:
            backgroundColorStyle = styles.orange;
    }

    return (
        <Layout
            footer={footerButton}
            baseZIndex={finalZIndex}
            containerClassName={styles.baseListViewContainer}
        >
            <div className={`${styles.actionSheetContainer}`}>
                <div className={`${styles.actionSheet} ${animate ? "" : styles.actionSheetNoAnimation}  ${sheetClassName} ${backgroundColorStyle}`}>
                    {headerContent}
                    {children &&
                        <div className={styles.customContent}>{children}</div>}
                    {footerContent}
                </div>
            </div>
        </Layout >
    );
};

export default BaseListView;
